import React from "react";
import Body from "../components/Body.jsx";
import CreateRequest from "../components/CreateRequest.jsx";

/**
 * Preview of the create request screen in the Flutter app.
 *
 * NOTE: This screen IS NOT interactive or accessible HTML. It exists ONLY to
 * help generate an app screenshot.
 */
export default function CreateRequestPreview() {
  return (
    <Body>
      <CreateRequest />
    </Body>
  );
}
